/** Capabilities — read-only list + detail + JSON Schema. */
import { apiGet } from '../client.js';
import type { Capability, CapabilitySchema } from '../types.js';

export function listCapabilities(): Promise<Capability[]> {
  return apiGet<Capability[]>('/api/v1/capabilities');
}

export function getCapabilitySchema(id: string): Promise<CapabilitySchema> {
  return apiGet<CapabilitySchema>(`/api/v1/capabilities/${id}/schema`);
}
